import React, { useMemo } from 'react';
import { compileListName } from '@stone/utils/analytics';
import ProductTilesListContext from '@stone/scripts/contexts/ProductTilesListContext';
import ProductTilesRail from '@stone/components/product/ProductTilesRail';
const ProductRecommendation = (props) => {
    /* ADD ANALYTICS CONTEXT */
    const listContextData = useMemo(() => {
        return { analyticsData: { item_list_name: compileListName(`/recommended/${props.slot}`) } };
    }, [props.product, props.productList]);
    return (React.createElement(ProductTilesListContext.Provider, { value: listContextData },
        React.createElement(ProductTilesRail, { railType: "CAROUSEL", tileType: "RECS", limit: props.limit, slot: props.slot, product: props.product })));
};
export default ProductRecommendation;
